import { ChangeEvent, useContext } from 'react';

import { Icon, Select } from '@atom/mui';
import { WorkIcon } from '@atom/mui/icons';
import { workOrderPriorityTypes } from '@atom/utilities/workOrderPriorityUtilities';
import { workOrderStatusTypes } from '@atom/utilities/workOrderStatusUtilities';

import FilterDateRange from './FilterDateRange';
import TemplateFilter from './TemplateFilter';
import TemplateFolderFilter from './TemplateFolderFilter';
import WorkOrdersFiltersContext from './WorkOrdersFiltersContext';
import WorkTemplateWorkFieldsFilter from './WorkTemplateWorkFieldsFilter';

import classes from './filters.module.css';

const { MenuItem } = Select;

const WorkFiltersSection = () => {
  const {
    filterForm,
    areFiltersDisabled,
    workOrderTemplate,
    updateFilterForm,
  } = useContext(WorkOrdersFiltersContext);

  const { selectStatuses, selectPriorities } = filterForm;

  const handlePrioritySelect = (event: ChangeEvent<HTMLInputElement>) => {
    updateFilterForm('selectPriorities', event.target.value);
  };

  const handleStatusSelect = (event: ChangeEvent<HTMLInputElement>) => {
    updateFilterForm('selectStatuses', event.target.value);
  };

  return (
    <div className={classes.filterSection}>
      <div className={classes.filterSectionHeader}>
        <Icon icon={WorkIcon} />
        Work
      </div>
      <FilterDateRange
        label="Due Date"
        presetField="workDueDateSelectValue"
        startField="workDueDateStart"
        endField="workDueDateEnd"
      />
      <FilterDateRange
        label="Completed Date"
        presetField="workCompletionDateSelectValue"
        startField="workCompletionDateStart"
        endField="workCompletionDateEnd"
      />
      <FilterDateRange
        label="Inventory Update Date"
        presetField="workAppliedDateSelectValue"
        startField="workAppliedDateStart"
        endField="workAppliedDateEnd"
      />
      <div className={classes.filterContainer}>
        <div className={classes.filterLabel}>Work Status</div>
        <Select
          multiple
          displayEmpty
          value={selectStatuses || []}
          onChange={handleStatusSelect}
          disabled={areFiltersDisabled}
          renderValue={selectStatuses.length > 0 ? null : () => 'All'}
          data-cy="workOrdersFilterStatusSelect"
        >
          {workOrderStatusTypes.map(status => (
            <MenuItem
              key={+status.value}
              value={+status.value}
              data-cy={`workOrdersFilterStatusOption-${status.label}`}
            >
              {status.label}
            </MenuItem>
          ))}
        </Select>
      </div>
      <div className={classes.filterContainer}>
        <div className={classes.filterLabel}>Priority</div>
        <Select
          multiple
          displayEmpty
          value={selectPriorities}
          onChange={handlePrioritySelect}
          disabled={areFiltersDisabled}
          renderValue={selectPriorities.length > 0 ? null : () => 'All'}
          data-cy="workOrdersFilterPrioritySelect"
        >
          {workOrderPriorityTypes.map(priority => (
            <MenuItem
              key={priority.value}
              value={priority.value}
              data-cy={`workOrdersFilterPriorityOption-${priority.value}`}
            >
              {priority.label}
            </MenuItem>
          ))}
        </Select>
      </div>
      <TemplateFolderFilter />
      <TemplateFilter />
      {workOrderTemplate && <WorkTemplateWorkFieldsFilter />}
    </div>
  );
};

export default WorkFiltersSection;
